// const deviceVersion = sessionStorage.getItem('deviceVersion') || '0.0.0'
// const zingVersion = sessionStorage.getItem('zingVersion') || '0.0.0'
// const connectedDevice = sessionStorage.getItem('connectedDevice')

var socketInitialState = {
    socket: null,
}

const socketReducer = (state = socketInitialState, action) => {
    switch (action.type) {
        case 'SOCKET': {
            console.log('SOCKET', action.payload)
            let data = {
                ...state,
            }
            data.socket = action.payload
            return data
        }
        default:
            return state
    }
}

export default socketReducer
